import { Modal } from "../ui/modal/Modal"
import { ModalError } from "../ui/modal/ModalError"
import { msg } from "../ui/modal/utils"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { useQuery } from "../../hooks/useQuery"
import { Trans, useTranslation } from "react-i18next"

export const ModalEliminarTag = ({ show, entry, setEntries }) => {
  const deleteEntry = useQuery()

  const handleDelete = async () => {
    const { url, opt } = await api.tags.delete({
      token: getCookie("jwt"),
      tag_id: entry.id,
    })

    // ejecuto
    deleteEntry.url.current = url
    deleteEntry.opt.current = opt

    deleteEntry.run({
      onOk: (data) => {
        setEntries((currents) => ({
          ...currents,
          entries: currents.entries.filter((c) => c.id !== entry.id),
        }))
        show[1](false)
      },
    })
  }

  const { t } = useTranslation()

  const modalFooter = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => show[1](false)}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-danger"
          disabled={deleteEntry.isPending}
          onClick={() => handleDelete()}>
          {deleteEntry.isPending
            ? t(`ui.btns.deleting`) + "..."
            : t(`ui.btns.yes`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="confirmar-accion"
        show={show}
        className="darkie"
        header={<center>{t(`ui.msgs.confirm_action`)}</center>}
        body={msg(
          <Trans
            i18nKey="modals.modal_delete_tag.are_you_sure"
            values={{ tag: entry.name }}
            components={{ b: <b /> }}
          />
        )}
        footer={modalFooter()}
      />

      {/* en caso de erro, muestro una modal */}

      {deleteEntry.res && deleteEntry.err && (
        <ModalError show={show} res={deleteEntry.res} />
      )}
    </>
  )
}
